let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bhIY6")).then(() => parcelRequire('8MeK7'));